import { rootReducer } from '..';

type RootState = ReturnType<typeof rootReducer>;

export const signUpEmailSelector = (state: RootState): string => state.auth.signUpEmail;

export const isLinkUserExistSelector = (state: RootState): boolean => state.auth.isLinkUserExist;

export const authActionSelector = (state: RootState) => state.auth.action;

export const authNameSelector = (state: RootState) => state.auth.signUpName;

export const onBoardingUserIdSelector = (state: RootState) => state.auth.onBoardingUserId;

export const newOnBoardingAnswersSelector = (state: RootState) => state.auth.newOnBoardingAnswers;

export const newOnBoardingDataSelector = (state: RootState) => state.auth.newOnBoardingData;

export const isTokenInitSelector = (state: RootState) => state.auth.isTokenInit;

export const isWebToWebAuthSelector = (state: RootState) => state.auth.isWebToWebAuth;

export const redirectToSelector = (state: RootState) => state.auth.redirectTo;

export const authStateSelector = (state: RootState) => state.auth;

export const onboardingDataSelector = (state: RootState) => state.auth.onboardingData;
